import RecentlyViewedList from '@ulta/components/RecentlyViewedList/RecentlyViewedList';

export default RecentlyViewedList;
